import { put, call } from 'redux-saga/effects';
import { fetchWithMisToken } from '../../../../utils/fetch-with-mis-token';
import {
    FETCH_CAREER_AND_SEASON_STATS,
    removeCareerAndSeasonStatsRequest,
    setCareerAndSeasonStats,
    setCareerAndSeasonStatsRequest,
    setCareerSeasonsStats
} from '../actions';

/**
 * @typedef {object} FetchCareerAndSeasonStatsAction
 * @property {object} payload
 * @property {string} payload.type
 * @property {string} payload.playerId
 * @property {string} [payload.seasonId]
 * @property {boolean} [payload.benchmarking]
 */

/**
 * @param {FetchCareerAndSeasonStatsAction} action - The Redux action.
 */
export function* fetchCareerAndSeasonStats(action) {
    const { type, playerId, seasonId } = action.payload;

    yield put(setCareerAndSeasonStatsRequest(action.payload));

    let data = {};

    if (playerId) {
        if (type === 'career') {
            data = yield call(
                fetchWithMisToken,
                `${PULSE.app.environment.statsPro}/playerCareerSeasonStats/${playerId}/benchmarked`
            );
    
            if (data.yearlySeasonStats) {
                yield put(setCareerAndSeasonStats(data));
            } else {
                // Error handling for when there is no data
                yield put(
                    setCareerAndSeasonStats({
                        yearlySeasonStats: ['no data available']
                    })
                );
            }
        } else {
            data = yield call(
                fetchWithMisToken,
                `${PULSE.app.environment.statsPro}/playerSeasonRoundStats/${playerId}?seasonId=${seasonId}`
            );
    
            if (data.roundStats) {
                yield put(setCareerSeasonsStats(data));
            } else {
                // Error handling for when there is no data
                yield put(
                    setCareerSeasonsStats({
                        seasonId: seasonId,
                        roundStats: [{ error: 'no data available' }]
                    })
                );
            }
        }
    }

    yield put(removeCareerAndSeasonStatsRequest(action.payload));

    yield put(FETCH_CAREER_AND_SEASON_STATS.success(data));
}
